import { z } from 'zod';
import { documentSchema } from '../document';
import { momentSchema } from '../momentSchema';

export const assessmentTypeSchema = z.enum(['baseline', 'post-injury']);
export type AssessmentType = z.infer<typeof assessmentTypeSchema>;

export const patientAssessmentOverviewSchema = documentSchema.and(
  z.object({
    lastAssessmentDate: momentSchema.nullable(),
    nextAssessmentType: assessmentTypeSchema
  })
);

export interface PatientAssessmentOverview
  extends z.infer<typeof patientAssessmentOverviewSchema> {}

export const assessmentIndexEntry = documentSchema.and(
  z.object({
    date: momentSchema,
    assessmentType: assessmentTypeSchema,
    /**
     * The questionnaire version. This must change whenever the schemas of the questionnaires changes.
     * This is not the same as the documents `metadata.schemaVersion`.
     */
    questionnaireVersion: z.string()
  })
);

export interface AssessmentIndexEntry
  extends z.infer<typeof assessmentIndexEntry> {}
